import { render, staticRenderFns } from "./showFullscreen-editor.vue?vue&type=template&id=65351a10&scoped=true"
import script from "./showFullscreen-editor.vue?vue&type=script&lang=js"
export * from "./showFullscreen-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65351a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65351a10')) {
      api.createRecord('65351a10', component.options)
    } else {
      api.reload('65351a10', component.options)
    }
    module.hot.accept("./showFullscreen-editor.vue?vue&type=template&id=65351a10&scoped=true", function () {
      api.rerender('65351a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/showFullscreen-editor.vue"
export default component.exports